import { z } from 'zod'

// Common validation schemas
export const uuidSchema = z.string().uuid()

export const emailSchema = z.string().email()

export const paginationSchema = z.object({
  page: z.number().int().min(1).default(1),
  limit: z.number().int().min(1).max(100).default(10),
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).default('desc')
})

export const dateRangeSchema = z.object({
  startDate: z.string().datetime().optional(),
  endDate: z.string().datetime().optional()
})

export const apiResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({
    success: z.boolean(),
    data: dataSchema.optional(),
    error: z.string().optional(),
    message: z.string().optional()
  })

export const errorResponseSchema = z.object({
  error: z.string(),
  timestamp: z.string().datetime(),
  path: z.string(),
  method: z.string(),
  details: z.any().optional(),
  stack: z.string().optional()
}) 